import Toast from "components/toast";
import { UploadService } from "services/upload";
import { CreateTrackContainerService } from "services/uploadMusic/createTrackContainer";
import { UploadTrackItemSevice } from "services/uploadMusic/uploadTrackItem";
import { GetArtistData } from "services/user/getUser";
import { IMusicData } from "types/musicData";

export const UploadTrack = async (data: IMusicData) => {
  try {
    if (!data.coverImage) {
      return;
    }
    const coverArtId = await UploadService(data?.coverImage);
    // //EP or ALBUM
    if (data.releaseType.toLowerCase() !== "single") {
      //Get EP/ALBUM id
      const containerId = await CreateTrackContainerService(data, coverArtId);

      //Upload Tracks to EP/ALBUM
      for (let i = 0; i < data.trackList.length; i++) {
        await UploadTrackItemSevice(
          data,
          coverArtId,
          i,
          true,
          containerId as string
        );
      }

      return containerId;
    } else {
      //Single Track
      const id = await UploadTrackItemSevice(data, coverArtId, 0, false);

      return id;
    }
  } catch (error) {
    throw error;
  }
};
